// ONE shared write path for every newsletter signup surface (footer box,
// account-signup checkbox, OAuth return). Mirrors the footer form's proven
// behavior: the Netlify function first (writes newsletter_emails + forwards to
// the MailerLite Film Revival group), with a direct Supabase insert as the
// fallback. The fallback matters for local dev QA too: localhost serves no
// Netlify functions, so signups there land in newsletter_emails only —
// MailerLite verification is a post-deploy step by design.
import { supabaseNewsletter } from '../supabase';

export async function subscribeToNewsletter(email) {
  const clean = (email || '').trim();
  if (!clean || !clean.includes('@')) return { ok: false };
  try {
    const res = await fetch('/.netlify/functions/subscribe-newsletter', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: clean }),
    });
    const data = await res.json();
    if (data && data.success) return { ok: true, alreadySubscribed: !!data.alreadySubscribed };
    throw new Error('subscribe-newsletter did not succeed');
  } catch {
    const r = await supabaseNewsletter.subscribe(clean);
    if (r.success) return { ok: true, fallback: true };
    if (/already subscribed/i.test(r.error || '')) return { ok: true, alreadySubscribed: true };
    return { ok: false };
  }
}

// A Google signup redirects away before we can subscribe, so the ticked box is
// remembered here and completed by AuthContext when the session lands back.
// Guarded there to freshly created accounts only, so a stale flag can never
// subscribe a returning user who abandoned the signup.
export const PENDING_NEWSLETTER_KEY = 'pendingNewsletterOptIn';
